import { TextField } from '@mui/material';
import { Editor as TinyMCEEditor } from 'tinymce';
import RichTextEditor, { MentionProps } from './RichTextEditor';

interface TextEditorsProps {
  additionalPlugins?: string[];
  disabled?: boolean;
  editorRef?: React.MutableRefObject<TinyMCEEditor | undefined>;
  editorSize?: number;
  error?: string;
  html?: boolean;
  initialTextValue?: string;
  maxSize?: number;
  mentions?: MentionProps;
  multiline?: boolean;
  onChangeHandler: (editorValue: string) => void;
  placeholder?: string;
  resizeMargin?: number;
  text: string;
  textInputLabel?: string;
  toolbarType: string;
  dataTestId?: string;
}

const TextEditors: React.FC<TextEditorsProps> = (props: TextEditorsProps) => {
  const {
    additionalPlugins = [],
    disabled,
    editorRef,
    editorSize,
    error,
    html = false,
    initialTextValue,
    maxSize,
    mentions,
    multiline,
    onChangeHandler,
    placeholder,
    resizeMargin,
    text,
    textInputLabel,
    toolbarType = '',
    dataTestId,
  } = props;

  if (html && editorRef) {
    return (
      <RichTextEditor
        additionalPlugins={additionalPlugins}
        disabled={disabled}
        editorRef={editorRef}
        editorSize={editorSize}
        error={error}
        initialTextValue={initialTextValue}
        label={textInputLabel}
        maxSize={maxSize}
        mentions={mentions}
        onChangeHandler={onChangeHandler}
        placeholder={placeholder}
        resizeMargin={resizeMargin}
        toolbarType={toolbarType}
        dataTestId={dataTestId}
      />
    );
  }

  return (
    <TextField
      color="secondary"
      disabled={disabled}
      error={!!error}
      fullWidth
      helperText={error}
      label={textInputLabel}
      multiline={multiline}
      onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
        onChangeHandler(e.target.value);
      }}
      placeholder={placeholder}
      required
      size="small"
      value={text}
      variant="outlined"
      data-testid={dataTestId}
    />
  );
};

export default TextEditors;
